import { useState } from "react";
import { url } from "../../../settings";

type Props = {
    name: string;
    surname: string;
    email: string;
    tel: string;
    message: string;
}

const useSendEmail = () => {
    const [statusMsg, setStatusMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    const initialEmailData = {
        name: "",
        surname: "",
        email: "",
        tel: "",
        message: ""
    };

    const send = async (e: React.FormEvent<HTMLFormElement>, emailData: Props) => {
        e.preventDefault();

        setIsLoading(true);

        const options = {
            method: "POST",
            body: JSON.stringify(emailData),
            headers: {
                "Content-Type": "application/json"
            }
        };

        try {
            const value = await fetch(url, options);

            switch (value.status) {
                case 201:
                    setStatusMsg("Повідомлення надісленно успішно!");
                    setIsSuccess(true);
                    break;
                case 400:
                    setStatusMsg("Не всі поля заповнені правильно!");
                    break;
                case 500:
                    setStatusMsg("Проблема з сервером 😵, спробуйте будь ласка пізніше!");
                    break;
                default:
                    setStatusMsg("Щось пішло не по плану 😵, повідомте будь ласка про це Катерину!");
                    break;
            }
        } catch (error) {
            setStatusMsg(`Сервер недоступний 😵, Спробуйте пізінше`);
        }
        finally {
            setIsLoading(false);
        }
    };

    return { send, initialEmailData, isLoading, statusMsg, isSuccess };
};

export default useSendEmail;